module.exports = __webpack_public_path__ + "7f78ee200118e05f4d25a5e2ae2659c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/login_2.png
// module id = 293
// module chunks = 0